
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/display-youtube-services",
      function () {
        return require("private-next-pages/services/display-youtube-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/display-youtube-services"])
      });
    }
  